export default __webpack_public_path__ + "static/media/bermix-studio-b8mwvvFs8Ak-unsplash.5a898213.jpg";